import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

interface IProps {
  title: string
  image?: any
}

const CollectionHero = ({ title, image }: IProps) => {
  return (
    <section>
      {image?.gatsbyImageData && (
        <div className="h-full w-full">
          <GatsbyImage
            image={image.gatsbyImageData}
            alt={image?.altText || title}
          />
        </div>
      )}
      <div className="collection-hero-container px-[15px] xl:px-28 pt-5">
        <span className="collections-bread-crumb text-[#1c1c1c] text-[11px]">
          <a href="/" className="hover:underline font-bold">
            Home
          </a>{" "}
          / {title}
        </span>
        <h1 className="mb-0 text-left font-black text-[#1c1c1c] text-2xl tracking-wide">
          {title}
        </h1>
      </div>
    </section>
  )
}

export default CollectionHero
